import EventModel from '@diziner/Events/EventModel';
export class NavigatedToPageIndex extends EventModel {
    static publish(data) {
        PubSub.publish(this.eventName, data);
    }
    static subscribe(callback) {
        return PubSub.subscribe(this.eventName, (msg, data) => callback(data));
    }
}
NavigatedToPageIndex.eventName = 'NavigatedToPageIndex';
